function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["sort"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { hasOwnProperty, isObject, isString } from 'vega-util';
import { isAggregateOp, isArgmaxDef, isArgminDef, SHARED_DOMAIN_OPS, MULTIDOMAIN_SORT_OP_INDEX as UNIONDOMAIN_SORT_OP_INDEX } from '../../aggregate';
import { isBinning, isBinParams, isParameterExtent } from '../../bin';
import { getSecondaryRangeChannel, isScaleChannel, isXorY } from '../../channel';
import { binRequiresRange, getBandPosition, getFieldOrDatumDef, hasBandEnd, isDatumDef, isFieldDef, valueExpr, vgField } from '../../channeldef';
import { DataSourceType } from '../../data';
import * as log from '../../log';
import { isPathMark, isRectBasedMark } from '../../mark';
import { hasDiscreteDomain, isDomainUnionWith, isParameterDomain } from '../../scale';
import { DEFAULT_SORT_OP, isSortArray, isSortByEncoding, isSortField } from '../../sort';
import { normalizeTimeUnit } from '../../timeunit';
import * as util from '../../util';
import { isDataRefDomain, isDataRefUnionedDomain, isFieldRefUnionDomain, isSignalRef } from '../../vega.schema';
import { getMarkConfig } from '../common';
import { getBinSignalName } from '../data/bin';
import { sortArrayIndexField } from '../data/calculate';
import { FACET_SCALE_PREFIX } from '../data/optimize';
import { OFFSETTED_RECT_END_SUFFIX, OFFSETTED_RECT_START_SUFFIX } from '../data/timeunit';
import { getScaleDataSourceForHandlingInvalidValues } from '../invalid/datasources';
import { isFacetModel, isUnitModel } from '../model';
import { SignalRefWrapper } from '../signal';
import { makeExplicit, makeImplicit, mergeValuesWithExplicit } from '../split';
export function parseScaleDomain(model) {
  if (isUnitModel(model)) {
    parseUnitScaleDomain(model);
  } else {
    parseNonUnitScaleDomain(model);
  }
}
function parseUnitScaleDomain(model) {
  var localScaleComponents = model.component.scales;
  var _iterator = _createForOfIteratorHelper(util.keys(localScaleComponents)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var channel = _step.value;
      var domains = parseDomainForChannel(model, channel);
      var localScaleCmpt = localScaleComponents[channel];
      localScaleCmpt.setWithExplicit('domains', domains);
      parseSelectionDomain(model, channel);
      if (model.component.data.isFaceted) {
        // get resolve from closest facet parent as this decides whether we need to refer to cloned subtree or not
        var facetParent = model;
        while (!isFacetModel(facetParent) && facetParent.parent) {
          facetParent = facetParent.parent;
        }
        var resolve = facetParent.component.resolve.scale[channel];
        if (resolve === 'shared') {
          var _iterator2 = _createForOfIteratorHelper(domains.value),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var domain = _step2.value;
              // Replace the scale domain with data output from a cloned subtree after the facet.
              if (isDataRefDomain(domain)) {
                // use data from cloned subtree (which is the same as data but with a prefix added once)
                domain.data = FACET_SCALE_PREFIX + domain.data.replace(FACET_SCALE_PREFIX, '');
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function parseNonUnitScaleDomain(model) {
  var _iterator3 = _createForOfIteratorHelper(model.children),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var child = _step3.value;
      parseScaleDomain(child);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  var localScaleComponents = model.component.scales;
  var _iterator4 = _createForOfIteratorHelper(util.keys(localScaleComponents)),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var channel = _step4.value;
      var domains = void 0;
      var selectionExtent = null;
      var _iterator5 = _createForOfIteratorHelper(model.children),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _child = _step5.value;
          var childComponent = _child.component.scales[channel];
          if (childComponent) {
            if (domains === undefined) {
              domains = childComponent.getWithExplicit('domains');
            } else {
              domains = mergeValuesWithExplicit(domains, childComponent.getWithExplicit('domains'), 'domains', 'scale', domainsTieBreaker);
            }
            var se = childComponent.get('selectionExtent');
            if (selectionExtent && se && selectionExtent.param !== se.param) {
              log.warn(log.message.NEEDS_SAME_SELECTION);
            }
            selectionExtent = se;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      localScaleComponents[channel].setWithExplicit('domains', domains);
      if (selectionExtent) {
        localScaleComponents[channel].set('selectionExtent', selectionExtent, true);
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}
/**
 * Remove unaggregated domain if it is not applicable
 * Add unaggregated domain if domain is not specified and config.scale.useUnaggregatedDomain is true.
 */
function normalizeUnaggregatedDomain(domain, fieldDef, scaleType, scaleConfig) {
  if (domain === 'unaggregated') {
    var _canUseUnaggregatedDo = canUseUnaggregatedDomain(fieldDef, scaleType),
      valid = _canUseUnaggregatedDo.valid,
      reason = _canUseUnaggregatedDo.reason;
    if (!valid) {
      log.warn(reason);
      return undefined;
    }
  } else if (domain === undefined && scaleConfig.useUnaggregatedDomain) {
    // Apply config if domain is not specified.
    var _canUseUnaggregatedDo2 = canUseUnaggregatedDomain(fieldDef, scaleType),
      _valid = _canUseUnaggregatedDo2.valid;
    if (_valid) {
      return 'unaggregated';
    }
  }
  return domain;
}
export function parseDomainForChannel(model, channel) {
  var scaleType = model.getScaleComponent(channel).get('type');
  var encoding = model.encoding;
  var domain = normalizeUnaggregatedDomain(model.scaleDomain(channel), model.typedFieldDef(channel), scaleType, model.config.scale);
  if (domain !== model.scaleDomain(channel)) {
    model.specifiedScales[channel] = _objectSpread(_objectSpread({}, model.specifiedScales[channel]), {}, {
      domain: domain
    });
  }
  // If channel is either X or Y then union them with X2 & Y2 if they exist
  if (channel === 'x' && getFieldOrDatumDef(encoding.x2)) {
    if (getFieldOrDatumDef(encoding.x)) {
      return mergeValuesWithExplicit(parseSingleChannelDomain(scaleType, domain, model, 'x'), parseSingleChannelDomain(scaleType, domain, model, 'x2'), 'domain', 'scale', domainsTieBreaker);
    } else {
      return parseSingleChannelDomain(scaleType, domain, model, 'x2');
    }
  } else if (channel === 'y' && getFieldOrDatumDef(encoding.y2)) {
    if (getFieldOrDatumDef(encoding.y)) {
      return mergeValuesWithExplicit(parseSingleChannelDomain(scaleType, domain, model, 'y'), parseSingleChannelDomain(scaleType, domain, model, 'y2'), 'domain', 'scale', domainsTieBreaker);
    } else {
      return parseSingleChannelDomain(scaleType, domain, model, 'y2');
    }
  }
  return parseSingleChannelDomain(scaleType, domain, model, channel);
}
function mapDomainToDataSignal(domain, type, timeUnit) {
  return domain.map(function (v) {
    var data = valueExpr(v, {
      timeUnit: timeUnit,
      type: type
    });
    return {
      signal: "{data: ".concat(data, "}")
    };
  });
}
function convertDomainIfItIsDateTime(domain, type, timeUnit) {
  var _normalizeTimeUnit;
  // explicit value
  var normalizedTimeUnit = (_normalizeTimeUnit = normalizeTimeUnit(timeUnit)) === null || _normalizeTimeUnit === void 0 ? void 0 : _normalizeTimeUnit.unit;
  if (type === 'temporal' || normalizedTimeUnit) {
    return mapDomainToDataSignal(domain, type, normalizedTimeUnit);
  }
  return [domain]; // Date time won't make sense
}
function parseSingleChannelDomain(scaleType, domain, model, channel) {
  var encoding = model.encoding,
    markDef = model.markDef,
    mark = model.mark,
    config = model.config,
    stack = model.stack;
  var fieldOrDatumDef = getFieldOrDatumDef(encoding[channel]);
  var type = fieldOrDatumDef.type;
  var timeUnit = fieldOrDatumDef['timeUnit'];
  var dataSourceTypeForScaleDomain = getScaleDataSourceForHandlingInvalidValues({
    invalid: getMarkConfig('invalid', markDef, config),
    isPath: isPathMark(mark)
  });
  if (isDomainUnionWith(domain)) {
    var defaultDomain = parseSingleChannelDomain(scaleType, undefined, model, channel);
    var unionWith = convertDomainIfItIsDateTime(domain.unionWith, type, timeUnit);
    return makeExplicit([].concat(_toConsumableArray(unionWith), _toConsumableArray(defaultDomain.value)));
  } else if (isSignalRef(domain)) {
    return makeExplicit([domain]);
  } else if (domain && domain !== 'unaggregated' && !isParameterDomain(domain)) {
    return makeExplicit(convertDomainIfItIsDateTime(domain, type, timeUnit));
  }
  if (stack && channel === stack.fieldChannel) {
    if (stack.offset === 'normalize') {
      return makeImplicit([[0, 1]]);
    }
    var data = model.requestDataName(dataSourceTypeForScaleDomain);
    return makeImplicit([{
      data: data,
      field: model.vgField(channel, {
        suffix: 'start'
      })
    }, {
      data: data,
      field: model.vgField(channel, {
        suffix: 'end'
      })
    }]);
  }
  var sort = isScaleChannel(channel) && isFieldDef(fieldOrDatumDef) ? domainSort(model, channel, scaleType) : undefined;
  if (isDatumDef(fieldOrDatumDef)) {
    var d = convertDomainIfItIsDateTime([fieldOrDatumDef.datum], type, timeUnit);
    return makeImplicit(d);
  }
  var fieldDef = fieldOrDatumDef; // now we can be sure it's a fieldDef
  if (domain === 'unaggregated') {
    var field = fieldOrDatumDef.field;
    return makeImplicit([{
      data: model.requestDataName(dataSourceTypeForScaleDomain),
      field: vgField({
        field: field,
        aggregate: 'min'
      })
    }, {
      data: model.requestDataName(dataSourceTypeForScaleDomain),
      field: vgField({
        field: field,
        aggregate: 'max'
      })
    }]);
  } else if (isBinning(fieldDef.bin)) {
    if (hasDiscreteDomain(scaleType)) {
      if (scaleType === 'bin-ordinal') {
        // we can omit the domain as it is inferred from the `bins` property
        return makeImplicit([]);
      }
      // ordinal bin scale takes domain from bin_range, ordered by bin start
      // This is useful for both axis-based scale (x/y) and legend-based scale (other channels).
      return makeImplicit([{
        // If sort by aggregation of a specified sort field, we need to use RAW table,
        // so we can aggregate values for the scale independently from the main aggregation.
        data: util.isBoolean(sort) ? model.requestDataName(dataSourceTypeForScaleDomain) : model.requestDataName(DataSourceType.Raw),
        // Use range if we added it and the scale does not support computing a range as a signal.
        field: model.vgField(channel, binRequiresRange(fieldDef, channel) ? {
          binSuffix: 'range'
        } : {}),
        // we have to use a sort object if sort = true to make the sort correct by bin start
        sort: sort === true || !isObject(sort) ? {
          field: model.vgField(channel, {}),
          op: 'min' // min or max doesn't matter since we sort by the start of the bin range
        } : sort
      }]);
    } else {
      // continuous scales
      var bin = fieldDef.bin;
      if (isBinning(bin)) {
        var binSignal = getBinSignalName(model, fieldDef.field, bin);
        return makeImplicit([new SignalRefWrapper(function () {
          var signal = model.getSignalName(binSignal);
          return "[".concat(signal, ".start, ").concat(signal, ".stop]");
        })]);
      } else {
        return makeImplicit([{
          data: model.requestDataName(dataSourceTypeForScaleDomain),
          field: model.vgField(channel, {})
        }]);
      }
    }
  } else if (fieldDef.timeUnit && util.contains(['time', 'utc'], scaleType)) {
    var fieldDef2 = encoding[getSecondaryRangeChannel(channel)];
    if (hasBandEnd(fieldDef, fieldDef2, markDef, config)) {
      var _data = model.requestDataName(dataSourceTypeForScaleDomain);
      var bandPosition = getBandPosition({
        fieldDef: fieldDef,
        fieldDef2: fieldDef2,
        markDef: markDef,
        config: config
      });
      var isRectWithOffset = isRectBasedMark(mark) && bandPosition !== 0.5 && isXorY(channel);
      return makeImplicit([{
        data: _data,
        field: model.vgField(channel, isRectWithOffset ? {
          suffix: OFFSETTED_RECT_START_SUFFIX
        } : {})
      }, {
        data: _data,
        field: model.vgField(channel, {
          suffix: isRectWithOffset ? OFFSETTED_RECT_END_SUFFIX : 'end'
        })
      }]);
    }
  }
  if (sort) {
    return makeImplicit([{
      // If sort by aggregation of a specified sort field, we need to use RAW table,
      // so we can aggregate values for the scale independently from the main aggregation.
      data: util.isBoolean(sort) ? model.requestDataName(dataSourceTypeForScaleDomain) : model.requestDataName(DataSourceType.Raw),
      field: model.vgField(channel),
      sort: sort
    }]);
  } else {
    return makeImplicit([{
      data: model.requestDataName(dataSourceTypeForScaleDomain),
      field: model.vgField(channel)
    }]);
  }
}
function normalizeSortField(sort, isStackedMeasure) {
  var op = sort.op,
    field = sort.field,
    order = sort.order;
  return _objectSpread(_objectSpread({
    // Apply default op
    op: op !== null && op !== void 0 ? op : isStackedMeasure ? 'sum' : DEFAULT_SORT_OP
  }, field ? {
    field: util.replacePathInField(field)
  } : {}), order ? {
    order: order
  } : {});
}
function parseSelectionDomain(model, channel) {
  var _model$fieldDef;
  var scale = model.component.scales[channel];
  var spec = model.specifiedScales[channel].domain;
  var bin = (_model$fieldDef = model.fieldDef(channel)) === null || _model$fieldDef === void 0 ? void 0 : _model$fieldDef.bin;
  var domain = isParameterDomain(spec) ? spec : undefined;
  var extent = isBinParams(bin) && isParameterExtent(bin.extent) ? bin.extent : undefined;
  if (domain || extent) {
    // As scale parsing occurs before selection parsing, we cannot set
    // domainRaw directly. So instead, we store the selectionExtent on
    // the scale component, and then add domainRaw during scale assembly.
    scale.set('selectionExtent', domain !== null && domain !== void 0 ? domain : extent, true);
  }
}
export function domainSort(model, channel, scaleType) {
  if (!hasDiscreteDomain(scaleType)) {
    return undefined;
  }
  // save to cast as the only exception is the geojson type for shape, which would not generate a scale
  var fieldDef = model.fieldDef(channel);
  var sort = fieldDef.sort;
  // if the sort is specified with array, use the derived sort index field
  if (isSortArray(sort)) {
    return {
      op: 'min',
      field: sortArrayIndexField(fieldDef, channel),
      order: 'ascending'
    };
  }
  var stack = model.stack;
  var stackDimensions = stack ? new Set([].concat(_toConsumableArray(stack.groupbyFields), _toConsumableArray(stack.stackBy.map(function (s) {
    return s.fieldDef.field;
  })))) : undefined;
  // Sorted based on an aggregate calculation over a specified sort field (only for ordinal scale)
  if (isSortField(sort)) {
    var isStackedMeasure = stack && !stackDimensions.has(sort.field);
    return normalizeSortField(sort, isStackedMeasure);
  } else if (isSortByEncoding(sort)) {
    var encoding = sort.encoding,
      order = sort.order;
    var fieldDefToSortBy = model.fieldDef(encoding);
    var aggregate = fieldDefToSortBy.aggregate,
      field = fieldDefToSortBy.field;
    var _isStackedMeasure = stack && !stackDimensions.has(field);
    if (isArgminDef(aggregate) || isArgmaxDef(aggregate)) {
      return normalizeSortField({
        field: vgField(fieldDefToSortBy),
        order: order
      }, _isStackedMeasure);
    } else if (isAggregateOp(aggregate) || !aggregate) {
      return normalizeSortField({
        op: aggregate,
        // can't be argmin/argmax since we don't support them in encoding field def
        field: field,
        order: order
      }, _isStackedMeasure);
    }
  } else if (sort === 'descending') {
    return {
      op: 'min',
      field: model.vgField(channel),
      order: 'descending'
    };
  } else if (util.contains(['ascending', undefined /* default =ascending*/], sort)) {
    return true;
  }
  // sort == null
  return undefined;
}
/**
 * Determine if a scale can use unaggregated domain.
 * @return {Boolean} Returns true if all of the following conditions apply:
 * 1. `scale.domain` is `unaggregated`
 * 2. Aggregation function is not `count` or `sum`
 * 3. The scale is quantitative or time scale.
 */
export function canUseUnaggregatedDomain(fieldDef, scaleType) {
  var aggregate = fieldDef.aggregate,
    type = fieldDef.type;
  if (!aggregate) {
    return {
      valid: false,
      reason: log.message.unaggregateDomainHasNoEffectForRawField(fieldDef)
    };
  }
  if (isString(aggregate) && !SHARED_DOMAIN_OPS.has(aggregate)) {
    return {
      valid: false,
      reason: log.message.unaggregateDomainWithNonSharedDomainOp(aggregate)
    };
  }
  if (type === 'quantitative') {
    if (scaleType === 'log') {
      return {
        valid: false,
        reason: log.message.unaggregatedDomainWithLogScale(fieldDef)
      };
    }
  }
  return {
    valid: true
  };
}
/**
 * Tie breaker for mergeValuesWithExplicit for domains. We concat the specified values.
 */
function domainsTieBreaker(v1, v2, property, propertyOf) {
  if (v1.explicit && v2.explicit) {
    log.warn(log.message.mergeConflictingDomainProperty(property, propertyOf, v1.value, v2.value));
  }
  // If equal score, concat the domains so that we union them later.
  return {
    explicit: v1.explicit,
    value: [].concat(_toConsumableArray(v1.value), _toConsumableArray(v2.value))
  };
}
/**
 * Converts an array of domains to a single Vega scale domain.
 */
export function mergeDomains(domains) {
  var uniqueDomains = util.unique(domains.map(function (domain) {
    // ignore sort property when computing the unique domains
    if (isDataRefDomain(domain)) {
      var _s = domain.sort,
        domainWithoutSort = _objectWithoutProperties(domain, _excluded);
      return domainWithoutSort;
    }
    return domain;
  }), util.hash);
  var sorts = util.unique(domains.map(function (d) {
    if (isDataRefDomain(d)) {
      var s = d.sort;
      if (s !== undefined && !util.isBoolean(s)) {
        if ('op' in s && s.op === 'count') {
          // let's make sure that if op is count, we don't use a field
          delete s.field;
        }
        if (s.order === 'ascending') {
          // drop order: ascending as it is the default
          delete s.order;
        }
      }
      return s;
    }
    return undefined;
  }).filter(function (s) {
    return s !== undefined;
  }), util.hash);
  if (uniqueDomains.length === 0) {
    return undefined;
  } else if (uniqueDomains.length === 1) {
    var domain = domains[0];
    if (isDataRefDomain(domain) && sorts.length > 0) {
      var _sort = sorts[0];
      if (sorts.length > 1) {
        log.warn(log.message.MORE_THAN_ONE_SORT);
        // Get sorts with non-default ops
        var filteredSorts = sorts.filter(function (s) {
          return isObject(s) && 'op' in s && s.op !== 'min';
        });
        if (sorts.every(function (s) {
          return isObject(s) && 'op' in s;
        }) && filteredSorts.length === 1) {
          _sort = filteredSorts[0];
        } else {
          _sort = true;
        }
      } else {
        // Simplify domain sort by removing field and op when the field is the same as the domain field.
        if (isObject(_sort) && 'field' in _sort) {
          var sortField = _sort.field;
          if (domain.field === sortField) {
            _sort = _sort.order ? {
              order: _sort.order
            } : true;
          }
        }
      }
      return _objectSpread(_objectSpread({}, domain), {}, {
        sort: _sort
      });
    }
    return domain;
  }
  // only keep sort properties that work with unioned domains
  var unionDomainSorts = util.unique(sorts.map(function (s) {
    if (util.isBoolean(s) || !('op' in s) || isString(s.op) && hasOwnProperty(UNIONDOMAIN_SORT_OP_INDEX, s.op)) {
      return s;
    }
    log.warn(log.message.domainSortDropped(s));
    return true;
  }), util.hash);
  var sort;
  if (unionDomainSorts.length === 1) {
    sort = unionDomainSorts[0];
  } else if (unionDomainSorts.length > 1) {
    log.warn(log.message.MORE_THAN_ONE_SORT);
    sort = true;
  }
  var allData = util.unique(domains.map(function (d) {
    if (isDataRefDomain(d)) {
      return d.data;
    }
    return null;
  }), function (x) {
    return x;
  });
  if (allData.length === 1 && allData[0] !== null) {
    // create a union domain of different fields with a single data source
    var _domain = _objectSpread({
      data: allData[0],
      fields: uniqueDomains.map(function (d) {
        return d.field;
      })
    }, sort ? {
      sort: sort
    } : {});
    return _domain;
  }
  return _objectSpread({
    fields: uniqueDomains
  }, sort ? {
    sort: sort
  } : {});
}
/**
 * Return a field if a scale uses a single field.
 * Return `undefined` otherwise.
 */
export function getFieldFromDomain(domain) {
  if (isDataRefDomain(domain) && isString(domain.field)) {
    return domain.field;
  } else if (isDataRefUnionedDomain(domain)) {
    var field;
    var _iterator6 = _createForOfIteratorHelper(domain.fields),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var nonUnionDomain = _step6.value;
        if (isDataRefDomain(nonUnionDomain) && isString(nonUnionDomain.field)) {
          if (!field) {
            field = nonUnionDomain.field;
          } else if (field !== nonUnionDomain.field) {
            log.warn(log.message.FACETED_INDEPENDENT_DIFFERENT_SOURCES);
            return field;
          }
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    log.warn(log.message.FACETED_INDEPENDENT_SAME_FIELDS_DIFFERENT_SOURCES);
    return field;
  } else if (isFieldRefUnionDomain(domain)) {
    log.warn(log.message.FACETED_INDEPENDENT_SAME_SOURCE);
    var _field = domain.fields[0];
    return isString(_field) ? _field : undefined;
  }
  return undefined;
}
export function assembleDomain(model, channel) {
  var scaleComponent = model.component.scales[channel];
  var domains = scaleComponent.get('domains').map(function (domain) {
    // Correct references to data as the original domain's data was determined
    // in parseScale, which happens before parseData. Thus the original data
    // reference can be incorrect.
    if (isDataRefDomain(domain)) {
      domain.data = model.lookupDataSource(domain.data);
    }
    return domain;
  });
  // domains is an array that has to be merged into a single vega domain
  return mergeDomains(domains);
}